module.exports = __webpack_public_path__ + "static/media/download-dark.8f650667.svg";